
import axios from './axiosInstance'

const setDefaults = () => {
  axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencode'
  axios.defaults.headers.common.Accept          = 'application/json'
}

const GetUser = ({ token, uid }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.get(`/users/${uid}`)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const GetUsers = ({ token, data }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/users', data)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const GetUserPoints = ({ token, email, alias }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/users/points/${email}`, { alias })
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const GetFavoriteVenues = ({ token, select }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/users/favoriteVenues/', {  select })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const ExportUsersSheet = ({ token }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.get('/users/exportSheet/')
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const UpdateUser = ({ token, user }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/users/update/${user._id}`, user)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const SearchUser = ({ token, term }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.get(`/users/search/${term}`)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const ChangeEmail = ({ token, uid, newEmail }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/users/changeemail', { uid, newEmail })
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const CheckEmail = ({ email }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.get(`/users/checkemail/${email}`)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const SetValidPhone = ({ token, uid, mobilePhone }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post(`/users/setvalidphone/${uid}`, { mobilePhone })
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const DeleteUser = ({ token, uid }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.delete(`/users/${uid}`)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const SetRole = ({ token, uid, claims }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/users/setrole', { uid, claims })
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

const AddFavoriteVenue = ({ token, _id, venue }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/users/addFavoriteVenue', { _id, venue })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const RemoveFavoriteVenue = ({ token, _id, venue }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/users/removeFavoriteVenue', { _id, venue })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const UnsubscribeMail = ({ user }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.post(`/users/unsubscribeMail/${user._id}`, user)
      .then(response => resolve(response.data))
      .catch((error) => { reject(error.response) })
  })
}

export {
  UnsubscribeMail,
  GetUser,
  GetUsers,
  GetFavoriteVenues,
  GetUserPoints,
  ExportUsersSheet,
  UpdateUser,
  SearchUser,
  ChangeEmail,
  CheckEmail,
  SetValidPhone,
  DeleteUser,
  SetRole,
  AddFavoriteVenue,
  RemoveFavoriteVenue
}
